import React, {Component} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { PopOut, Icon, Button } from 'components'
import { PageInput, ViewControl } from 'features'
import { Page } from 'schema'
import { pageContext } from 'context'
import { FaFileAlt } from 'react-icons/fa'
import { AnimateSharedLayout, motion } from 'framer-motion';

import classes from './PageHeader.module.css'
import * as actionCreators from 'store/actions'

const Header = styled.div`
    margin-top: 3rem;
    margin-bottom: 1rem;
    width: 100%;
    padding-left: ${props => props.full_screen ? '2.5vw' 
                    : props.full_width ? 'var(--main-padding-width-small)' : 'var(--main-padding-width)'};
    padding-right: ${props => props.full_screen ? '2.5vw'  
                    : props.full_width ? 'var(--main-padding-width-small)' : 'var(--main-padding-width)'};
    @media (max-width: 1024px) {
        padding-left: ${props => props.full_screen ? '5vw' : 'var(--main-padding-width-small)'};
        padding-right: ${props => props.full_screen ? '5vw' : 'var(--main-padding-width-small)'};
    }
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const DefaultIcon = styled.div`
    width: max-content;
    padding: 0.2rem;
    border: 1px solid var(--secondary-accent-color);
    border-radius: 5px;
    color: var(--secondary-accent-color);
    font-size: 0.7rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    opacity: ${props => props.hoverTitle ? 1 : 0};
    :hover{
        filter: brightness(var(--brightness));
    }
`

const buttonStyle = {
    backgroundColor: 'var(--secondary-color)',
    margin: '0 0.5rem 0 0',
}

const selectedStyle = {
    backgroundColor: 'var(--focus-color)',
    margin: '0 0.5rem 0 0',
    color: 'white',
    hoverColor: 'white'
}

class PageHeader extends Component {
    constructor(props){
        super(props);
        this.state = {
            hoverTitle: false, 
        }
    }

    _getPage = () => {
        let page_details = this.props.data['pages'][this.props.activePageID]
        page_details['pageID'] = this.props.activePageID
        const page = new Page(page_details)
        return page
    }
    
    onViewSelectHandler = (value) => {
        const updatedPage = this._getPage()
        updatedPage['page_view'] = value
        this.props.updatePage(updatedPage, this.props.data, this.props.uid)
    }

    onSelectIconHandler = (value, type) => {
        const updatedPage = this._getPage()
        updatedPage['icon'] = {value: value, type: type}
        this.props.updatePage(updatedPage, this.props.data, this.props.uid)
    }

    render() {
        const page = this._getPage()
        const view = page['page_view']

        return (
            <Header 
                full_width={this.props.user ? this.props.user.full_width || view === pageContext.VIEWS.KANBAN_VIEW || view === pageContext.VIEWS.CALENDAR_VIEW : null}
                full_screen={view === pageContext.VIEWS.CALENDAR_VIEW || view === pageContext.VIEWS.KANBAN_VIEW}>
                    <AnimateSharedLayout>
                        <motion.div layout='position' className={classes.PageInfo}
                            onMouseOver={() => this.setState({hoverTitle: true})} 
                            onMouseLeave={() => this.setState({hoverTitle: false})}>
                            <Icon size='3rem' defaultIcon={<FaFileAlt style={{fontSize: '3rem'}}/>}
                                value={page.icon && page.icon['value']}
                                type={page.icon && page.icon['type']}
                                onSubmit={this.onSelectIconHandler}/>

                            <PopOut trigger='leftClick' element={<PageInput page={page}/>}>
                                <div className={classes.PageName}>{page.page_name}</div>
                            </PopOut>
                        </motion.div>

                        <motion.div layout='position' className={classes.Wrapper}>
                            <div className={classes.PageOptions}>
                                <Button text='List' styles={view === pageContext.VIEWS.LIST_VIEW ? selectedStyle : buttonStyle} 
                                    icon={pageContext.ICONS.LIST_VIEW}
                                    onSelect={() => this.onViewSelectHandler(pageContext.VIEWS.LIST_VIEW)}/>
                                <Button text='Kanban' styles={view === pageContext.VIEWS.KANBAN_VIEW ? selectedStyle : buttonStyle} 
                                    icon={pageContext.ICONS.KANBAN_VIEW}
                                    onSelect={() => this.onViewSelectHandler(pageContext.VIEWS.KANBAN_VIEW)}/>
                            </div>

                            <ViewControl pageID={this.props.activePageID}/>
                        </motion.div>
                    </AnimateSharedLayout>
                    
            </Header>
        )
    }
}

const mapStateToProps = state => {
    return {
        data: state.db.present.data && state.db.present.data.toJS(),
        uid: state.auth.uid,
        activePageID: state.auth.activePageID,
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updatePage: (page, data, userId) => dispatch(actionCreators.updatePage(page, data, userId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);

PageHeader.propTypes = {
    id: PropTypes.string,
    page: PropTypes.instanceOf(Page),
    pageID: PropTypes.string,
    type: PropTypes.oneOf(['Button', 'Input']),
}